import { useEffect, useRef } from 'react';
var useClickOutsideListener = function (options) {
    var onClickOutside = options.onClickOutside, _a = options.events, events = _a === void 0 ? ['mousedown'] : _a, scope = options.scope;
    var nodeRef = useRef(null);
    // @ts-ignore
    var handleClickOutside = function (event) {
        if (!nodeRef.current)
            return;
        // Handle keyboard events
        if (event instanceof KeyboardEvent) {
            if (event.type === 'keydown' || event.type === 'keyup') {
                onClickOutside(event);
            }
            return;
        }
        // Handle focus and blur events
        if (event instanceof FocusEvent) {
            if (event.type === 'focus' || event.type === 'blur') {
                onClickOutside(event);
            }
            return;
        }
        // Handle click and touch events
        if (!nodeRef.current.contains(event.target)) {
            onClickOutside(event);
        }
    };
    useEffect(function () {
        var _scope = scope === null ? null : scope || document;
        if (_scope !== null) {
            events.forEach(function (event) { return _scope.addEventListener(event, handleClickOutside); });
            return function () {
                events.forEach(function (event) { return _scope.removeEventListener(event, handleClickOutside); });
            };
        }
    }, [events, scope, handleClickOutside]);
    return nodeRef;
};
export default useClickOutsideListener;
